import { useState } from "react";
import { auditSearchOptions } from "../../../utils/Constants";
import secureLocalStorage from "react-secure-storage";

const SearchInput = ({
  loc,
  handleOnChange,
  searchBarShow,
  searchField,
  setSearchField,
  searchValue,
  setSearchValue,
}) => {
  const isAuditPage = loc.pathname.replace("/", "").toLowerCase() === "audits";

  const onFieldChange = (e) => {
    const field = e.target.value;

    setSearchField(field);
    setSearchValue("");

    secureLocalStorage.removeItem("searchKeyword");
    secureLocalStorage.removeItem("hasSearchedValue");

     // Back Date Audits should execute immediately
  if (field === "BackDateAudits") {
    setSearchValue("BackDateAudits");

    handleOnChange(
      {
        target: {
          value: "BackDateAudits",
        },
      },
      field,
    );

    return;
  }
     // Reset to initial listing
    //if (!field) {
      handleOnChange(
        {
          target: {
            value: "",
          },
        },
        "",
      );
    //}
  };

  const slsRole = secureLocalStorage.getItem("role");

  const filteredAuditSearchOptions =
    slsRole === process.env.REACT_APP_AROLE ||
    slsRole === process.env.REACT_APP_QC
      ? auditSearchOptions
      : auditSearchOptions.filter(
          (option) => option.value !== "BackDateAudits",
        );
  return (
    <div
      className={
        isAuditPage && searchBarShow
          ? "search-container withDrpdown"
          : "search-container"
      }
    >
      {isAuditPage && searchBarShow && (
        <select
          className="search-dropdown"
          value={searchField}
          onChange={onFieldChange}
        >
          {filteredAuditSearchOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      )}

      {((!isAuditPage && searchBarShow) ||
        (isAuditPage && searchBarShow && searchField && searchField !== "BackDateAudits")) && (
        <input
          type="text"
          className="inputS"
          placeholder={
            isAuditPage
              ? `Search by ${searchField}...`
              : `Search ${loc.pathname.replace("/", "")}...`
          }
          value={searchValue}
          onChange={(e) => {
            let value = e.target.value;

            if (searchField === "Score") {
              value = value.replace(/%/g, "");
            }
            setSearchValue(value);

            handleOnChange(
              {
                target: { value },
              },
              searchField,
            );
          }}
        />
      )}
    </div>
  );
};

export default SearchInput;
